<template>
  <!-- 业绩统计的明细 -->
  <div
    v-if="dialogVisible"
    class="detail"
  >
    <el-dialog
      custom-class="detail-dialog"
      :visible.sync="dialogVisible"
      :show-close="false"
      :before-close="cancelAction"
      width="1026px"
    >
      <div>
        <div class="dialog-top">
          <div class="dialog-left">
            <div
              v-if="activeName === 'guide'"
              class="dialog-label"
            >
              {{ dataInfo.store_name }}
            </div>
            <div
              v-else
              class="dialog-label"
            >
              {{ dataInfo.customer_base_name }}
            </div>
            <div class="dialog-content">
              <div class="top-text">
                <template v-if="activeName === 'guide'">
                  <el-avatar
                    v-if="dataInfo.salesperson_avatar"
                    class="avatar"
                    shape="circle"
                    :size="34"
                    fit="fill"
                    :src="dataInfo.salesperson_avatar"
                  />
                  <i
                    v-else
                    slot="reference"
                    class="iconfont icon-user-circle1"
                  />
                </template>

                <span>{{ dataInfo.salesperson_name }}</span>
              </div>
              <el-date-picker
                v-model="date"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月"
                :picker-options="pickerOptions"
                @change="changeMonth"
              />
            </div>
          </div>

          <div class="dialog-right">
            <div>
              <div class="dialog-label">
                累计销售额（元）
              </div>
              <div class="count">
                {{ dataInfo.total.pay_fee }}
              </div>
            </div>
            <div>
              <div class="dialog-label">
                累计订单数
              </div>
              <div
                v-if="activeName === 'guide'"
                class="count"
              >
                {{ dataInfo.total.pay_num }}
              </div>
              <div
                v-else
                class="count"
              >
                {{ dataInfo.total.order_num }}
              </div>
            </div>
            <div v-if="activeName !== 'community'">
              <div class="dialog-label">
                累计顾客数
              </div>
              <div class="count">
                {{ dataInfo.total.user_num }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0)"
        >
          <el-card
            v-if="dataInfo.rebate_fee"
            class="box-card"
            shadow="never"
          >
            <div class="dialog-card">
              <div class="card-left">
                <div class="dialog-label">
                  已确认提成（元）
                </div>
                <div class="count">
                  {{ dataInfo.rebate_fee.total.confirm_rebate_fee }}
                </div>
              </div>
              <ul class="data-list">
                <!-- 导购和门店的数据展示部分 -->
                <template v-if="activeName !== 'community'">
                  <li v-if="dataInfo.rebate_fee.sales">
                    <div class="list-title">
                      云店销售提成（元）
                    </div>
                    <div class="list-data">
                      <div class="list-count">
                        {{ dataInfo.rebate_fee.sales.confirm_rebate_fee }}
                      </div>
                      <div class="list-status">
                        已确认
                      </div>
                    </div>
                    <div class="list-data">
                      <div class="list-count">
                        {{ dataInfo.rebate_fee.sales.unconfirm_rebate_fee }}
                      </div>
                      <div class="list-status">
                        未确认
                      </div>
                    </div>
                  </li>
                  <!-- <li>
                    <div class="list-title">
                      门店开单提成（元）
                    </div>
                    <div class="list-data">
                      <div class="list-count">
                        {{ dataInfo.rebate_fee.store.confirm_rebate_fee }}
                      </div>
                      <div class="list-status">已确认</div>
                    </div>
                    <div class="list-data">
                      <div class="list-count">
                        {{ dataInfo.rebate_fee.store.unconfirm_rebate_fee }}
                      </div>
                      <div class="list-status">未确认</div>
                    </div>
                  </li> -->
                  <li>
                    <div class="list-title">
                      绑定会员提成（元）
                    </div>
                    <div class="list-data">
                      <div class="list-count">
                        {{ dataInfo.rebate_fee.binduser.confirm_rebate_fee }}
                      </div>
                      <div class="list-status">
                        已确认
                      </div>
                    </div>
                    <div class="list-data">
                      <div class="list-count">
                        {{ dataInfo.rebate_fee.binduser.unconfirm_rebate_fee }}
                      </div>
                      <div class="list-status">
                        未确认
                      </div>
                    </div>
                  </li>
                </template>
                <!-- 社群数据展示部分 -->
                <template v-if="activeName === 'community'">
                  <li :style="{ marginRight: '150px' }">
                    <div class="list-title">
                      销售提成（元）
                    </div>
                    <div class="list-data">
                      <div class="list-count">
                        {{ dataInfo.rebate_fee.total.confirm_rebate_fee }}
                      </div>
                      <div class="list-status">
                        已确认
                      </div>
                    </div>
                    <div class="list-data">
                      <div class="list-count">
                        {{ dataInfo.rebate_fee.total.unconfirm_rebate_fee }}
                      </div>
                      <div class="list-status">
                        未确认
                      </div>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </el-card>

          <table
            class="dialog-table"
            width="100%"
          >
            <!-- 导购,门店和社群共有 -->
            <tr>
              <td class="tab-title">
                退款金额（元）
              </td>
              <td>
                <span class="table-count">{{ dataInfo.refund.fee }}</span>
              </td>
              <td class="tab-title">
                退款订单数
              </td>
              <td>
                <span class="table-count">{{ dataInfo.refund.num }}</span>
              </td>
            </tr>

            <!-- 社群列表 -->
            <template v-if="activeName === 'community'">
              <tr>
                <td class="tab-title">
                  云店销售额（元）
                </td>
                <td>
                  <span class="table-count">{{ dataInfo.pay_fee.online.this_month }}</span>
                  <template>
                    <span>{{ dataInfo.pay_fee.online.gap }}</span>
                    <i
                      v-if="dataInfo.pay_fee.online.gap > 0"
                      class="el-icon-caret-top"
                    />
                    <i
                      v-if="dataInfo.pay_fee.online.gap < 0"
                      class="el-icon-caret-bottom"
                    />
                  </template>
                </td>
                <td class="tab-title">
                  门店订单数
                </td>
                <td>
                  <span class="table-count">{{ dataInfo.pay_num.online.this_month }}</span>
                  <span>{{ dataInfo.pay_num.online.gap }}</span>
                  <i
                    v-if="dataInfo.pay_num.online.gap > 0"
                    class="el-icon-caret-top"
                  />
                  <i
                    v-if="dataInfo.pay_num.online.gap < 0"
                    class="el-icon-caret-bottom"
                  />
                </td>
              </tr>
            </template>
            <!-- 导购和门店列表 -->
            <template v-if="activeName !== 'community'">
              <tr>
                <td class="tab-title">
                  云店销售额（元）
                </td>
                <td>
                  <span class="table-count">{{ dataInfo.pay_fee.online.this_month }}</span>
                  <template>
                    <span>{{ dataInfo.pay_fee.online.gap }}</span>
                    <i
                      v-if="dataInfo.pay_fee.online.gap > 0"
                      class="el-icon-caret-top"
                    />
                    <i
                      v-if="dataInfo.pay_fee.online.gap < 0"
                      class="el-icon-caret-bottom"
                    />
                  </template>
                </td>
                <td class="tab-title">
                  门店销售额（元）
                </td>
                <td>
                  <span class="table-count">{{ dataInfo.pay_fee.offline.this_month }}</span>
                  <span>{{ dataInfo.pay_fee.offline.gap }}</span>
                  <i
                    v-if="dataInfo.pay_fee.offline.gap > 0"
                    class="el-icon-caret-top"
                  />
                  <i
                    v-if="dataInfo.pay_fee.offline.gap < 0"
                    class="el-icon-caret-bottom"
                  />
                </td>
              </tr>
              <tr>
                <td class="tab-title">
                  云店订单数
                </td>
                <td>
                  <span class="table-count">{{ dataInfo.pay_num.online.this_month }}</span>
                  <span>{{ dataInfo.pay_num.online.gap }}</span>
                  <i
                    v-if="dataInfo.pay_num.online.gap > 0"
                    class="el-icon-caret-top"
                  />
                  <i
                    v-if="dataInfo.pay_num.online.gap < 0"
                    class="el-icon-caret-bottom"
                  />
                </td>
                <td class="tab-title">
                  门店订单数
                </td>
                <td>
                  <span class="table-count">{{ dataInfo.pay_num.offline.this_month }}</span>
                  <span>{{ dataInfo.pay_num.offline.gap }}</span>
                  <i
                    v-if="dataInfo.pay_num.offline.gap > 0"
                    class="el-icon-caret-top"
                  />
                  <i
                    v-if="dataInfo.pay_num.offline.gap < 0"
                    class="el-icon-caret-bottom"
                  />
                </td>
              </tr>
              <tr>
                <td class="tab-title">
                  新增客户数
                </td>
                <td>
                  <span class="table-count">{{ dataInfo.user_num.new.this_month }}</span>
                  <span>{{ dataInfo.user_num.new.gap }}</span>
                  <i
                    v-if="dataInfo.user_num.new.gap > 0"
                    class="el-icon-caret-top"
                  />
                  <i
                    v-if="dataInfo.user_num.new.gap < 0"
                    class="el-icon-caret-bottom"
                  />
                </td>
                <td class="tab-title">
                  绑定客户数
                </td>
                <td>
                  <span class="table-count">{{ dataInfo.user_num.bind.this_month }}</span>
                  <span>{{ dataInfo.user_num.bind.gap }}</span>
                  <i
                    v-if="dataInfo.user_num.bind.gap > 0"
                    class="el-icon-caret-top"
                  />
                  <i
                    v-if="dataInfo.user_num.bind.gap < 0"
                    class="el-icon-caret-bottom"
                  />
                </td>
              </tr>
              <tr>
                <td class="tab-title">
                  下单客户数
                </td>
                <td colspan="3">
                  <span class="table-count">{{ dataInfo.user_num.pay.this_month }}</span>
                  <span>{{ dataInfo.user_num.pay.gap }}</span>
                  <i
                    v-if="dataInfo.user_num.pay.gap > 0"
                    class="el-icon-caret-top"
                  />
                  <i
                    v-if="dataInfo.user_num.pay.gap < 0"
                    class="el-icon-caret-bottom"
                  />
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dataObj from '../untils/datalist'
let today =
  new Date().getFullYear() +
  '-' +
  (new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1)

export default {
  props: ['dialogVisible', 'dialogData', 'activeName', 'dialogDate'],
  data () {
    return {
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      },
      date: today, //日期默认当前月份
      data: {}, //从父组件传过来的数据
      dataInfo: dataObj, //组件渲染数据
      loading: true //组件的loading
    }
  },
  watch: {
    dialogData (newV) {
      if (newV) {
        this.data = newV
        this.date = this.dialogDate ? this.dialogDate : today
        if (this.activeName === 'guide') {
          this.getGuideInfo()
        } else {
          this.getCommunityInfo()
        }
      }
    }
  },
  mounted () {},
  methods: {
    // 关闭明细模态框
    cancelAction () {
      this.$emit('closeDetailDialog')
    },

    // 获取明细数据
    async getGuideInfo () {
      this.loading = true
      const { salesperson_id, store_id } = this.data
      const res = await this.$api.performance.getGuideStatisticInfo(salesperson_id, {
        salesperson_id,
        store_id,
        date: this.date
      })
      if (res) {
        this.dataInfo = res
        this.loading = false
      }
    },

    async getCommunityInfo () {
      this.loading = true
      const { salesperson_id, chat_id } = this.data
      const res = await this.$api.performance.getCommunityInfo({
        salesperson_id,
        chat_id,
        date: this.date
      })
      if (res) {
        this.dataInfo = res
        this.loading = false
      }
    },

    // 更改查询月份
    changeMonth () {
      if (this.activeName === 'guide') {
        this.getGuideInfo()
      } else {
        this.getCommunityInfo()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail-dialog {
  .el-dialog__header {
    display: none;
  }
  .dialog-top {
    margin-top: -35px;
    display: flex;
    justify-content: space-between;
    .dialog-left {
      .dialog-content {
        display: flex;
        align-items: center;
        .top-text {
          height: 36px;
          display: flex;
          align-items: center;
          font-size: 24px;
          margin-right: 50px;
          .avatar {
            margin-right: 10px;
          }
          .iconfont {
            font-size: 34px;
            color: #ccc;
            margin-right: 10px;
          }
        }
      }
    }
    .dialog-right {
      display: flex;
      justify-content: flex-end;
      > div {
        margin-left: 50px;
      }
    }
  }

  .box-card {
    margin-top: 20px;
    .dialog-card {
      display: flex;
      justify-content: space-between;
      .card-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
      }
      .data-list {
        display: flex;
        justify-content: flex-end;
        li {
          margin-left: 50px;
          .list-title {
            margin-bottom: 15px;
          }
          .list-data {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .list-count {
              font-size: 18px;
            }
            .list-status {
              color: #999;
              font-size: 12px;
              margin-left: 20px;
            }
          }
        }
      }
    }
  }

  .dialog-table {
    border-collapse: collapse;
    tr {
      td {
        border: 1px solid#ebeef5;
        height: 48px;
        padding: 0 20px;
        box-sizing: border-box;
      }
      .tab-title {
        width: 20%;
        background-color: rgb(250, 250, 250);
      }
      .table-count {
        color: #303133;
        font-size: 18px;
        display: inline-block;
        width: 80px;
      }
      .el-icon-caret-top {
        color: rgb(126, 191, 80);
        margin-left: 5px;
        font-size: 10px;
      }
      .el-icon-caret-bottom {
        color: red;
        margin-left: 5px;
        font-size: 10px;
      }
    }
  }

  .dialog-label {
    margin-bottom: 15px;
    color: #999;
  }
  .count {
    font-size: 26px;
    padding-right: 5px;
    line-height: 36px;
  }
}
</style>
